import Header from '../components/Header';
import NewDashboard from '../components/NewDashboard';

const Index = () => {
  // Mock data for demo - multiple dates to test filtering
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);
  const dayBefore = new Date(today);
  dayBefore.setDate(today.getDate() - 2);

  const mockStandupData = [
    // Today's entries
    {
      user_name: 'Sarah Johnson',
      completed_work: 'Finished the user authentication flow and fixed the dashboard loading issue.',
      planned_work: 'Will start working on the notification system and attend the client meeting.',
      blockers: '',
      created_at: today.toISOString(),
      sentiment: 0.4 // Positive mood
    },
    {
      user_name: 'Mike Chen',
      completed_work: 'Deployed the new payment integration to staging and tested all edge cases.',
      planned_work: 'Planning to work on the mobile responsive design and optimize queries.',
      blockers: '',
      created_at: today.toISOString(),
      sentiment: 0.3 // Positive mood
    },
    // Yesterday's entries
    {
      user_name: 'John Smith',
      completed_work: 'Completed user research interviews and compiled the feedback report.',
      planned_work: 'Will present research findings and begin prototyping new designs.',
      blockers: 'Need design system approval before proceeding.',
      created_at: yesterday.toISOString(),
      sentiment: 0.1 // Slightly positive but has blockers
    },
    {
      user_name: 'Sarah Johnson',
      completed_work: 'Set up new development environment and configured CI/CD pipeline.',
      planned_work: 'Work on API documentation and review security audit.',
      blockers: '',
      created_at: yesterday.toISOString(),
      sentiment: 0.2 // Positive mood
    },
    // Day before yesterday
    {
      user_name: 'Mike Chen',
      completed_work: 'Fixed critical bugs in the checkout process.',
      planned_work: 'Implement new feature toggles and update dependencies.',
      blockers: 'Waiting for API access from third-party vendor.',
      created_at: dayBefore.toISOString(),
      sentiment: -0.1 // Slightly negative due to blockers
    }
  ];

  const mockStats = {
    totalStandups: 247,
    thisWeekStandups: 23,
    voiceMemos: 18,
    avgSentiment: 0.3,
    voicePercentage: 73
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-[#F2F4ED] to-[#E8EBE3] relative">
      {/* Subtle peaceful background elements */}
      <div className="absolute inset-0 overflow-hidden opacity-20">
        <div className="absolute top-20 right-20 w-64 h-64 bg-gradient-to-br from-[#F2F4ED]/60 to-[#E8EBE3]/60 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 left-20 w-80 h-80 bg-gradient-to-tr from-[#E8EBE3]/50 to-[#F2F4ED]/50 rounded-full blur-3xl"></div>
      </div>
      
      <Header />
      <main className="relative z-10">
        <NewDashboard 
          teamId="demo-team"
          teamName="Demo Team"
          standupData={mockStandupData}
          teamStats={mockStats}
          teamMemberCount={3}
        />
      </main>
    </div>
  );
};

export default Index;
